module.exports = __webpack_public_path__ + "6700cdcae182b4e0c5f592dc90e84f1f.svg";